import React, { Component } from 'react';
import styled from 'styled-components';
import firebase from 'firebase';
import { fromUnixTime, format, formatDistance } from 'date-fns';
import { Redirect } from 'react-router-dom';

import liveChatLogo from './../lib/assets/liveChat/liveChatLogo.svg';
import liveChatAdd from './../lib/assets/liveChat/add.svg';

const LiveChatMsgRootContainer = styled.div`
	background-color: #ffffff;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	flex: 1;
	padding: 20px;
	/* height: 100vh; */
	justify-content: space-between;
`;

const LiveChatLogoContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 50px;
	width: 100%;
`;

const LiveChatLogo = styled.img`
	display: block;
	height: 50px;
`;

const LiveChatConversation = styled.div`
	border-bottom-color: #e2e2e2;
	border-bottom-style: solid;
	border-bottom-width: 1px;
	display: flex;
	flex-direction: column;
	flex: 1;
	/* max-height: 400px; */
	overflow-y: auto;
	width: 100%;
	min-height: 500px;
	max-height: 500px;
`;
const LiveChatSupportBubbleRootContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;

const LiveChatSupportBubbleContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const LiveChatSupportBubble = styled.div`
	background-color: #272d2d;
	border-radius: 10px 10px 0 10px;
	color: #ffffff;
	padding: 20px;
`;

const LiveChatUserBubbleRootContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
`;

const LiveChatUserBubbleContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
`;

const LiveChatUserBubble = styled.div`
	background-color: #edba5d;
	border-radius: 10px 10px 10px 0;
	color: #ffffff;
	padding: 20px;
`;

const LiveChatMsgTime = styled.p`text-align: ${(props) => (props.endBadge ? 'right' : 'left')};`;

const SendMsgContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: row;
	height: 40px;
	padding-top: 20px;
`;

const SendMsgAdd = styled.img`
	height: 24px;
	margin-right: 20px;
`;

const SendMsgTextInput = styled.input`
	border: none;
	display: flex;
	flex: 1;
`;

const SendMsgButton = styled.button`
	background-color: #edba5d;
	border-radius: 8px;
	color: #ffffff;
	height: 24px;
	margin-left: 20px;
	border: none;
`;

const CloseLiveChatButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 10px;
`;

const CloseLiveChatButton = styled.button`
	background-color: #272d2d;
	border-radius: 8px;
	color: #ffffff;
	height: 24px;
	margin-left: 20px;
	width: 90px;
`;

const ChatMsgInputContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const ImageView = styled.img`
	display: block;
	margin-bottom: 10px;
	max-width: 200px;
	width: 100%;
	cursor: pointer;
`;

const ImageModalView = styled.img`
	display: block;
	margin-bottom: 10px;
	max-width: 800px;
	max-height: 600px;
	width: 100%;
`;

const ModalViewContainer = styled.div`
	background-color: #00000090;
	bottom: 0;
	display: flex;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`;

class ChatView extends Component {
	constructor(props) {
		super();

		this.state = {
			ticketId: props.match.params.id,
			chatMsg: [],
			textInput: '',
			redirectAfterClosedTicket: false,
			isModalVisible: false,
			modalImageIndex: '',
			modalImage: ''
		};
	}

	fetchAllChatMsg = () => {
		const db = firebase.firestore();
		const state = { ...this.state };
		const ref = db
			.collection('livechat')
			.doc(this.state.ticketId)
			.collection('msg')
			.orderBy('created', 'asc')
			.get();
		ref.then((snap) => {
			const allChatMsgs = [];

			snap.forEach((doc) => {
				const msg = {
					userEmail: doc.data().userEmail,
					id: doc.id,
					statusText: doc.data().statusText,
					created: doc.data().created
				};
				allChatMsgs.push(msg);
			});
			state.chatMsg = allChatMsgs;

			this.setState({ ...state });
		});
	};

	handleModalView = (imageIndex) => {
		const state = { ...this.state };
		state.isModalVisible = true;
		state.modalImageIndex = imageIndex;
		state.modalImage = state.chatMsg[imageIndex].downloadURL;

		this.setState({ ...state });
	};

	handleRemoveModal = () => {
		const state = { ...this.state };
		state.isModalVisible = false;
		state.modalImageIndex = '';
		state.modalImage = '';

		this.setState({ ...state });
	};

	closeTicket = () => {
		const db = firebase.firestore();
		const ref = db.collection('livechat').doc(this.state.ticketId).update({ statusClosed: true });

		ref.then((res) => {
			this.setState({ redirectAfterClosedTicket: true });
		});
	};

	scrollToBottom = () => {
		// this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
		this.messagesEnd.scrollTo(0, 10000);
	};

	handleTextInput = (e) => {
		console.log('_________e', e);

		this.setState({ textInput: e.target.value });
	};

	handleEnterKey = (e) => {
		if (e.key == 'Enter') {
			this.sendNewMsg();
		}
	};

	sendNewMsg = () => {
		const currentUser = firebase.auth().currentUser;
		const db = firebase.firestore();
		const ref = db.collection('livechat').doc(this.state.ticketId).collection('msg').add({
			created: firebase.firestore.FieldValue.serverTimestamp(),
			done: true,
			downloadURL: '',
			refPath: '',
			statusClosed: false,
			statusMediaType: '',
			statusText: this.state.textInput,
			support: true,
			uid: currentUser.uid,
			email: currentUser.email
		});
		ref.then((res) => {
			console.log('__________res', res);

			const state = { ...this.state };
			state.textInput = '';

			this.setState({ ...state });
		});
	};

	componentDidMount() {
		this.scrollToBottom();
		console.log('_________this.props', this.props);
		console.log('_________this.state', this.state);

		// this.fetchAllChatMsg();
		const db = firebase.firestore();
		const state = { ...this.state };
		this.fetchNew = db
			.collection('livechat')
			.doc(this.state.ticketId)
			.collection('msg')
			.orderBy('created', 'asc')
			.onSnapshot((snapshot) => {
				console.log('_____querySnapshot ChatView', snapshot);

				snapshot.docChanges().forEach((change) => {
					console.log('_________change1111 data', change);

					if (change.type == 'added') {
						const msgObj = {
							created: change.doc.data().created,
							created1: change.doc.data().created,
							done: change.doc.data().done,
							downloadURL: change.doc.data().downloadURL,
							refPath: change.doc.data().refPath,
							statusClosed: change.doc.data().statusClosed,
							statusMediaType: change.doc.data().statusMediaType,
							statusText: change.doc.data().statusText,
							support: change.doc.data().support,
							uid: change.doc.data().uid,
							userEmail: change.doc.data().userEmail,
							id: change.doc.id
						};
						state.chatMsg.push(msgObj);
						this.setState({ ...state });
					}
				});
				// this.setState({ ...state });
			});
	}

	componentDidUpdate() {
		if (!this.state.redirectAfterClosedTicket) {
			this.scrollToBottom();
		}
	}

	componentWillUnmount() {
		this.fetchNew();
	}

	render() {
		if (this.state.redirectAfterClosedTicket) {
			return <Redirect to="/livechat" />;
		}

		return (
			<LiveChatMsgRootContainer>
				<LiveChatLogoContainer>
					<LiveChatLogo src={liveChatLogo} />
				</LiveChatLogoContainer>
				<LiveChatConversation ref={(chatMsg) => (this.messagesEnd = chatMsg)}>
					{console.log('_______state msg', this.state)}
					{this.state.chatMsg.map((msg, index) => {
						console.log('_________msg id', msg);

						if (msg.uid == firebase.auth().currentUser.uid) {
							return (
								<LiveChatSupportBubbleRootContainer key={msg.id}>
									<LiveChatSupportBubbleContainer>
										<LiveChatSupportBubble>{msg.statusText}</LiveChatSupportBubble>
										<LiveChatMsgTime>
											{msg.created ? format(msg.created.toDate(), 'HH:mm, d MMM') : null}
										</LiveChatMsgTime>
									</LiveChatSupportBubbleContainer>
								</LiveChatSupportBubbleRootContainer>
							);
						} else {
							return (
								<LiveChatUserBubbleRootContainer key={msg.id}>
									<LiveChatUserBubbleContainer>
										<LiveChatUserBubble>
											{msg.statusMediaType == 'image' ? (
												<ImageView
													src={msg.downloadURL}
													onClick={() => this.handleModalView(index)}
												/>
											) : null}
											{msg.statusText}
										</LiveChatUserBubble>
										<LiveChatMsgTime>
											{msg.created ? format(msg.created.toDate(), 'HH:mm, d MMM') : null}
										</LiveChatMsgTime>
									</LiveChatUserBubbleContainer>
								</LiveChatUserBubbleRootContainer>
							);
						}
					})}
				</LiveChatConversation>
				{this.state.isModalVisible ? (
					<ModalViewContainer onClick={() => this.handleRemoveModal()}>
						<ImageModalView src={this.state.modalImage} />
					</ModalViewContainer>
				) : null}

				<ChatMsgInputContainer>
					<CloseLiveChatButtonContainer>
						<CloseLiveChatButton onClick={() => this.closeTicket()}>Close ticket</CloseLiveChatButton>
					</CloseLiveChatButtonContainer>
					<SendMsgContainer>
						{/* <SendMsgAdd src={liveChatAdd} /> */}
						<SendMsgTextInput
							type="text"
							placeholder="Type your message here"
							onChange={(e) => this.handleTextInput(e)}
							value={this.state.textInput}
							onKeyPress={(e) => this.handleEnterKey(e)}
							required
						/>
						<SendMsgButton onClick={() => this.sendNewMsg()}>Send</SendMsgButton>
					</SendMsgContainer>
				</ChatMsgInputContainer>
			</LiveChatMsgRootContainer>
		);
	}
}

export default ChatView;
